<template>
  <!-- <div style="width: 100%; text-align: center"> -->
  <button
    class="buttonAGeneral"
    :class="{ disabled: disabled }"
    :disabled="disabled"
  >
    <p class="p-botones">{{ texto }}</p>
  </button>

  <!-- </div> -->
</template>
<script>
export default {
  name: "BtnAComponent",
  props: {
    texto: String,
    disabled: Boolean,
    modal: Boolean,
  },
};
</script>
<style scoped>
.buttonAGeneral {
  height: var(--margin40);
  background: linear-gradient(180deg, #00b79e 0%, #03eccb 100%);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 15.22vw;
  padding: var(--gap10) var(--gapH20);
  margin: 0px auto;
  border: none;
  min-width: 15.22vw;
}
.buttonAGeneral p {
  color: #fff;
  margin: 0px;
}
.buttonAGeneral.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 770px) {
  .buttonAGeneral {
    width: 200px;
  }
}
</style>
